import { render } from "./PbsTree.vue?vue&type=template&id=291b1d5a&scoped=true&ts=true"
import script from "./PbsTree.vue?vue&type=script&lang=ts"
export * from "./PbsTree.vue?vue&type=script&lang=ts"

import "./PbsTree.vue?vue&type=style&index=0&id=291b1d5a&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-291b1d5a"]])

export default __exports__